import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import Basic from './Basic/index';
import Small from './Small/index';
import Large from './Large/index';
import Custom from './Custom/index';
import States from './States/index';
import MultiBars from './MultiBars/index';
import Striped from './Stripped/index';
import Animated from './Animated/index';

const ProgressBarsContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Progress' parent='Ui Kits' title='Progress' />
      <Row>
        <Col sm='6'>
          <Large />
        </Col>
        <Col sm='6'>
          <Basic />
        </Col>
        <Col sm='6'>
          <Small />
        </Col>
        <Col sm='6'>
          <Custom />
        </Col>
        <Col sm='12'>
          <MultiBars />
        </Col>
        <Col sm='6'>
          <States />
        </Col>
        <Col sm='6'>
          <Striped />
        </Col>
        <Col sm='12'>
          <Animated />
        </Col>
      </Row>
    </Container>
  );
};

export default ProgressBarsContainer;
